import { PageBuilderContentTypes } from '../../../utils/pageBuilder/types';
import { PageBuilderText } from './Text';
import { PageBuilderHeading } from './Heading';
import { PageBuilderImage } from './Image';
import { PageBuilderLink } from './Link';
import { PageBuilderButtons, PageBuilderButtonItem } from './Button';

export const pageBuilderContentTypes: PageBuilderContentTypes = {
  text: PageBuilderText,
  heading: PageBuilderHeading,
  image: PageBuilderImage,
  link: PageBuilderLink,
  buttons: PageBuilderButtons,
  'button-item': PageBuilderButtonItem
};
